import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IS_SPINNER_ACTIVE } from 'src/app/util/interceptors';
import { UrlService } from 'src/environments/urlService';
import { FollowOnModelDTO } from '../component/dto/FollowOnModelDTO';
import { FollowOnModelsWithAllocation } from '../component/dto/FollowOnModelsWithAllocation';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CommitmentAllocationModelBackendService {
  private readonly url: string;

  constructor(
    private http: HttpClient,
    private urlService: UrlService,
  ) {
    this.url = this.urlService.getFmsUrl() + 'growth-potential';
  }

  getData(fundUUID: string, date: Date, modelUUID: string): Promise<FollowOnModelsWithAllocation> {
    const period: string = date.toString();
    return firstValueFrom(this.http.get<FollowOnModelsWithAllocation>(this.url + '/allocation', {
      params: { fundUUID, period, modelUUID },
      withCredentials: true,
    }));
  }

  /**
   * Saves a model, returns a wrapper, containing data for the saved model, as well as an updated list of all saved models
   *
   * @param model a model being saved
   * @param isAdmin is a flag to a backend indicating whether a returned wrapper should contain models with hidden periods or not
   */
  save(model: FollowOnModelsWithAllocation, isAdmin: boolean): Promise<FollowOnModelsWithAllocation> {
    return firstValueFrom(this.http.put<FollowOnModelsWithAllocation>(this.url, model, {
      params: { isAdmin },
      context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
      withCredentials: true,
    }));
  }

  delete(modelUUID: string): Promise<void> {
    return firstValueFrom(this.http.delete<void>(this.url, { context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
      params: { modelUUID },
      withCredentials: true },
    ));
  }

  /**
   * Gets either all models or only models with periods that whose fundPerformance is marked as visible based on isAdmin flag.
   */
  getSavedModels(fundUUID: string, isAdmin: boolean): Promise<FollowOnModelDTO[]> {
    return firstValueFrom(this.http.get<FollowOnModelDTO[]>(this.url + '/saved-models', {
      params: { fundUUID, isAdmin },
      withCredentials: true,
    }));
  }

  async deleteNewInvestments(newInvestmentsUuids: string[], fundUUID: string): Promise<void> {
    return firstValueFrom(this.http.delete<void>(this.url + '/new-investments', {
      context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
      params: { newInvestmentsUuids, fundUUID },
      withCredentials: true,
    }));
  }
}
